module.exports = __webpack_public_path__ + "static/image2-cc02be09cc67b33a628c0bb314fdf1ce.jpg";